import {
    ADD_TAMARAH_FAILED, ADD_TAMARAH_LOADING, ADD_TAMARAH_REMOVE, ADD_TAMARAH_SUCCESS
} from "../types";

const initialState = {
    loading: false,
    error: null,
    status: null,
    Tamara: null,
    request: null,
};

export const TamaraReducer = (
    state = initialState,
    action: { type: any; loading: any; payload: any; status: any; error: any, request: any }
) => {
    switch (action.type) {
        case ADD_TAMARAH_LOADING:
            return {
                ...state,
                loading: true,
            };
        case ADD_TAMARAH_SUCCESS:
            return {
                ...state,
                loading: false,
                tamara: action.payload,
                status: action.status,
                error: null,
                request: action.request
            };
        case ADD_TAMARAH_FAILED:
            return {
                ...state,
                loading: false,
                status: action.status,
                error: action.error,
                request: action.request

            };
        case ADD_TAMARAH_REMOVE:
            return initialState

        default:
            return state;
    }
};




